import { StyledSelect } from '@/components/styles'
import { SelectBase } from '@/components'

export default React.memo(function SelectSpecialists({
  specialists = [],
  activeId,
  placeholder,
  onChange,
  disabled,
  ...otherProps
}) {
  const selectedSpecialist = specialists.find(spec => spec.id === activeId)
  let headTitle
  if (selectedSpecialist) {
    const { first_name: fName, last_name: lName, patronymic } = selectedSpecialist
    headTitle = `${lName} ${fName.charAt(0)}.${patronymic?.charAt(0) ? patronymic?.charAt(0) + '.' : ''}`
  }

  return (
    <SelectBase
      title={headTitle || placeholder}
      closeOnClick={true}
      disabled={disabled}
      {...otherProps}
    >
      {specialists.map(specialist => {
        const { id, first_name: fName, last_name: lName, patronymic } = specialist
        const title = `${lName} ${fName.charAt(0)}.${patronymic?.charAt(0) ? patronymic?.charAt(0) + '.' : ''}`
        const checked = id === activeId

        return (
          <StyledSelect.Item key={id} isActive={checked}>
            <StyledSelect.Radio>
              <StyledSelect.RadioInput
                type="radio"
                name="specialist"
                value={id}
                checked={checked}
                onChange={onChange ? () => onChange(id) : undefined}
              />
              <StyledSelect.RadioTitle>{title}</StyledSelect.RadioTitle>
            </StyledSelect.Radio>
          </StyledSelect.Item>
        )
      })}
    </SelectBase>
  )
})
